import Link from "ds/components/Link";
import useFlowsIntegration from "shared/Flows/useFlowsIntegration";
import { getFlowsTriggerUrl, parseFlowsTrigger } from "utils/flows";

type TriggeredByFlowsProps = {
  triggeredBy: string;
};

const TriggeredByFlows = ({ triggeredBy }: TriggeredByFlowsProps) => {
  const { flowsIntegration } = useFlowsIntegration();
  const trigger = parseFlowsTrigger(triggeredBy);

  if (!trigger) {
    return <>{triggeredBy}</>;
  }

  if (!flowsIntegration) {
    return <>Flows</>;
  }

  return (
    <Link
      href={getFlowsTriggerUrl(flowsIntegration.baseURL, trigger)}
      target="_blank"
      rel="noopener noreferrer"
      inheritFont
      noEllipsis
    >
      Flows
    </Link>
  );
};

export default TriggeredByFlows;
